import styled from '@emotion/styled';
import { MessageCitations } from '@trinity/chat-components/components/Chat.Message.Citations/index';
import { RelatedQuestionsPane } from '../QueryHints';
import { ChatResponsePane } from '../ResponsePane';

export const MessageBody = styled.div({
  maxWidth: 600,
});

export const MessageContainer = styled.div({
  paddingRight: 20,
  paddingLeft: 20,
});

export const Copy = styled.div({
  marginBottom: 15,
});

export const ProfileItem = styled.div({
  marginBottom: 12,
});

export const Label = styled.div(({ theme }) => ({
  fontFamily: theme.fonts.bold,
  display: 'flex',
  alignItems: 'center',
  gap: 5,
}));

export const SectionContent = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
});

export const QuickActionsList = styled.div({
  marginTop: 0,
  marginBottom: 0,
  paddingLeft: 30,
  display: 'inline-flex',
  flexDirection: 'column',
  gap: 5,

  '& *': {
    justifyContent: 'flex-start',
  },
});

export const StyledRelatedQuestions = styled(RelatedQuestionsPane)({
  marginTop: 15,
});

export const StyledCitationsPane = styled(ChatResponsePane)({
  marginTop: 15,
});

export const StyledMessageCitations = styled(MessageCitations)({
  marginTop: 10,
});

export const SmallHint = styled.div(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.gray.dark1,
  marginTop: 4,
}));

export const Guidelines = styled.em({
  marginTop: 15,
});

export const MetricCardGrid = styled.div({
  display: 'flex',
  gap: 12,
  flexWrap: 'wrap',
});

export const MetricCard = styled.div({
  padding: '8px 16px',
  background: '#f8f9fa',
  borderRadius: 8,
  minWidth: 120,
});

export const MetricLabel = styled.div({
  fontSize: 11,
  color: '#666',
});

export const MetricValue = styled.div({
  fontSize: 18,
  fontWeight: 600,
});

export const StyledList = styled.ul({
  marginTop: 0,
  marginBottom: 0,
  paddingLeft: 30,
  whiteSpace: 'normal',
});

export const StyledListItem = styled.li({
  marginTop: 0,
  marginBottom: 5,
  whiteSpace: 'normal',

  '&:last-child': {
    marginBottom: 0,
  },
});

export const StyledProfileWidgetP = styled.p({
  marginTop: 0,
  marginBottom: 0,
  whiteSpace: 'normal',
});

export const Footer = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginTop: 15,
  gap: 10,
});

export const Recommendations = styled.div({
  marginTop: 10,
});
